var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loading',{attrs:{"active":_vm.loading,"is-full-page":true,"opacity":_vm.opacity,"color":"#339AF0"},on:{"update:active":function($event){_vm.loading=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }